import { apiFetch } from '@/shared/api/client'

export type KitchenPickerItem = { id: string; code: string; name: string }
export type DelmanPickerItem = { id: string; code: string; name: string }

/** GET /warehouse/kitchens — picker dapur tujuan dispatch (§3.2). */
export async function fetchKitchens(): Promise<KitchenPickerItem[]> {
  const res = await apiFetch<{ kitchens: KitchenPickerItem[] }>('/warehouse/kitchens')
  return res.kitchens ?? []
}

/** GET /warehouse/delmans — picker delman gudang tujuan dispatch (§3.2). */
export async function fetchDelmans(): Promise<DelmanPickerItem[]> {
  const res = await apiFetch<{ delmans: DelmanPickerItem[] }>('/warehouse/delmans')
  return res.delmans ?? []
}
